export default "__VITE_ASSET__DrbmwXl1__"